import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import LoyaltyTierIcon from 'LuxKit/Icons/loyalty/LoyaltyTierIcon'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import { useAppSelector } from 'hooks/reduxHooks'
import FormatLoyaltyPoints from 'loyalty/components/Formatters/FormatLoyaltyPoints'
import getLoyaltyDisplayTier from 'loyalty/selectors/getLoyaltyDisplayTier'
import { rem } from 'polished'
import styled from 'styled-components'
import type { LoyaltyLandingPageHowItWorksDetails } from './LoyaltyLandingPageHowItWorksSection'

const HowItWorksPill = styled.div`
  height: ${rem(56)};
  display: flex;
  align-items: center;
  background-color: ${props => props.theme.palette.neutral.default.eight};
  border: 1px solid ${props => props.theme.palette.neutral.default.six};
  border-radius: ${props => props.theme.borderRadius.round};
  padding: ${rem(8)} ${rem(16)};
  width: auto;
  position: relative;
`

const StatusPillContent = styled(Group)`
  > * + * {
    margin-left: -${rem(5)};
  }
`

const SavingsBar = styled.div`
  width: ${rem(110)};
  height: ${rem(6)};
  background: linear-gradient(
    to right,
    var(--progress-color) 0% 40%,
    ${props => props.theme.palette.neutral.default.five} 40% 100%
  );
  border-radius: ${props => props.theme.borderRadius.round};

  &.tier-bronze { --progress-color: ${props => props.theme.palette.product.loyalty.bronze.darkForeground}; }
  &.tier-silver { --progress-color: ${props => props.theme.palette.product.loyalty.silver.darkForeground}; }
  &.tier-gold { --progress-color: ${props => props.theme.palette.product.loyalty.gold.darkForeground}; }
  &.tier-platinum { --progress-color: ${props => props.theme.palette.product.loyalty.platinum.darkForeground}; }
`

const SavingsTierIcon = styled(LoyaltyTierIcon)`
  position: absolute;
  left: ${rem(40)};
  top: 50%;
  transform: translateY(-50%);
`

interface Props {
  item: LoyaltyLandingPageHowItWorksDetails
}

function LoyaltyLandingPageHowItWorksItem(props: Props) {
  const { item } = props
  const displayTier = useAppSelector(getLoyaltyDisplayTier)

  return <Group
    direction="vertical"
    horizontalAlign="start"
    gap={16}
    key={item.title}
  >
    <HowItWorksPill>
      {item.type === 'earn' && <Group direction="horizontal" gap={12} verticalAlign="center">
        <LoyaltyTierIcon tier={displayTier} size="L" />
        <BodyText variant="medium">
          <FormatLoyaltyPoints abbreviated points={10000} />
        </BodyText>
      </Group>}
      {item.type === 'status' && <StatusPillContent direction="horizontal">
        <LoyaltyTierIcon tier="silver" size="L" />
        <LoyaltyTierIcon tier="gold" size="L" />
        <LoyaltyTierIcon tier="platinum" size="L" />
      </StatusPillContent>}
      {item.type === 'savings' && <>
        <SavingsBar className={`tier-${displayTier}`} />
        <SavingsTierIcon tier={displayTier} size="L" />
      </>}
    </HowItWorksPill>
    <VerticalSpacer gap={8}>
      <Heading variant="heading4">{item.title}</Heading>
      <BodyText variant="medium">{item.description}</BodyText>
    </VerticalSpacer>
  </Group>
}

export default LoyaltyLandingPageHowItWorksItem
